<section>
	<ul class="p-0">
		@let dots =
			[
				{ key: "green", label: "bestBidder" },
				{ key: "red", label: "outbidOffer" },
				{ key: "yellow", label: "reserveNotMatched" }
			];

		@for (d of dots; track d.key) {
			<li
				class="legend-{{ d.key }}"
				[ngClass]="vertical ? '' : 'd-lg-inline-block' + ($index ? ' ms-lg-4' : '')"
			>
				<strong class="lh-lg">
					<span class="align-middle">{{ "auction.live." + d.label | translate }}</span>
				</strong>
			</li>
		}
	</ul>
	<p>
		{{ "auction.live.noOffers" | translate }}<br />
		{{ "auction.live.impegnoAcquisto" | translate }}
	</p>
</section>